import React from "react";

/**
 * ClientCommunity
 */
const ClientCommunity = () => {
  return (
    <>
      <iframe src={`https://missioncommunity.super.site/`} width="100%" style={{ height: "100vh" }} />
    </>
  );
};

export default ClientCommunity;
